import React from "react";

import LinkButton from "components/button/LinkButton";
import Textlink from "components/link/Textlink";

const OutOfStockNotice = ({ brand, brandPageUrl, model }) => (
  <div
    className="page-container max-w-md px-5 py-10 rounded"
    style={{ backgroundColor: "rgba(255,255,255, 0.75)" }}
  >
    <div className="headline--6 text-center text-secondary font-bold">
      Leider sind gerade alle
      {" "}
      {brand}
      {" "}
      {model}
      {" "}
      Angebote ausverkauft. Wir arbeiten
      daran, so schnell wie möglich Nachschub zu besorgen.
    </div>
    <div
      className={`flex flex-col items-center pt-10 pb-5 xl:pb-0 ${
        brandPageUrl ? "" : "mb-20"
      }`}
    >
      {brandPageUrl && (
        <LinkButton
          large
          href={brandPageUrl || ""}
          color="secondary"
          classNames={["mb-4", "whitespace-normal"]}
        >
          Andere
          {" "}
          {brand}
          {" "}
          Modelle entdecken
        </LinkButton>
      )}
      <Textlink to="/">Zur Startseite</Textlink>
    </div>
  </div>
);

export default OutOfStockNotice;
